interface OrganizationMembership_OrganizationRoleData {
  id: number;
  organizationMembershipId: number;
  organizationRoleId: number;
  createDate: string;
  createrId: number;
  updateDate: string;
  updaterId: number;
  deleteDate: string;
  deleterId: number;
}


export class OrganizationMembership_OrganizationRole {
  public static getNonTranslatableFields(): string[] { return ['id', 'organizationMembershipId', 'organizationRoleId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'organizationMembershipId', 'organizationRoleId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  organizationMembershipId?: number;
  organizationRoleId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;


  public static fromAPI(data: OrganizationMembership_OrganizationRoleData): OrganizationMembership_OrganizationRole {
    return new OrganizationMembership_OrganizationRole(data);
  }

  public static fromAPIList(data: OrganizationMembership_OrganizationRoleData[]): OrganizationMembership_OrganizationRole[] {
    return data.map((item: any) => OrganizationMembership_OrganizationRole.fromAPI(item));
  }

  constructor({id, organizationMembershipId, organizationRoleId, createDate, createrId, updateDate, updaterId, deleteDate, deleterId} : OrganizationMembership_OrganizationRoleData) {
    this.id = id;
    this.organizationMembershipId = organizationMembershipId;
    this.organizationRoleId = organizationRoleId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;
  }

  public toJson(): Object {
    return {
      id: this.id,
      organizationMembershipId: this.organizationMembershipId,
      organizationRoleId: this.organizationRoleId,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
}
